import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminWebhooksRoutingModule } from './admin-webhooks-routing.module';
import { AdminWebhooksComponent } from './admin-webhooks.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AdminWebhooksRoutingModule, SharedPipesModule, NgxTippyModule],
  declarations: [AdminWebhooksComponent],
})
export class AdminWebhooksModule {}
